import { cva } from "class-variance-authority";

export { default as Item } from "./Item.vue";
export { default as List } from "./List.vue";
export { default as ScrollableList } from "./ScrollableList.vue";
export { default as SearchableList } from "./SearchableList.vue";
export { default as ToggleGroupItem } from "./ToggleGroupItem.vue";

export const itemVariants = cva(
    "flex items-center justify-between border rounded-md gap-3 hover:cursor-pointer data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-30 transition-all select-none",
    {
        variants: {
            variant: {
                default: "py-3 px-4",
                filter: "h-12",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);
